var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4935 0H15.2422V4.71125H19.9997V1.32845C20.001 1.32845 19.7646 0.128477 18.4935 0Z",
    fill: "#1967D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2422 19.978V19.9895V19.9998L19.9997 15.2886H19.957L15.2422 19.978Z",
    fill: "#1967D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 15.2883V15.2461L19.957 15.2883H19.9993Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 4.71143H15.2422V15.2465H19.9997V4.71143Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.957 15.2886H15.2422V19.978L19.957 15.2886Z",
    fill: "#EA4335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2422 15.2883H19.957L19.9997 15.2461H15.2422V15.2883Z",
    fill: "#EA4335"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2305 19.9895H15.242V19.978L15.2305 19.9895Z",
    fill: "#34A853"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65039 15.2461V19.9895H15.231L15.2427 15.2461H4.65039Z",
    fill: "#34A853"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.242 15.2885V15.2461L15.2305 19.9895L15.242 19.9779V15.2885Z",
    fill: "#34A853"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2461V18.5441C0.0426274 19.6143 1.20002 19.9895 1.20002 19.9895H4.65026V15.2461H0Z",
    fill: "#188038"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65026 4.71125H15.2425V0H1.33437C1.33437 0 0.0852548 0.128477 0 1.45564V15.2464H4.65026V4.71125Z",
    fill: "#4285F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11648 13.114C7.87415 13.114 7.64048 13.0824 7.41546 13.0193C7.19621 12.9562 6.99426 12.8615 6.80963 12.7352C6.625 12.6032 6.46056 12.4397 6.31632 12.2446C6.17784 12.0495 6.0711 11.8228 5.99609 11.5645L7.06062 11.1428C7.13562 11.4297 7.26256 11.6478 7.44142 11.797C7.62028 11.9404 7.8453 12.0122 8.11648 12.0122C8.23765 12.0122 8.35304 11.9949 8.46267 11.9605C8.5723 11.9203 8.6675 11.8658 8.74827 11.797C8.82905 11.7281 8.89252 11.6478 8.93868 11.5559C8.9906 11.4584 9.01657 11.3493 9.01657 11.2288C9.01657 10.9763 8.92137 10.7784 8.73096 10.6349C8.54633 10.4914 8.28958 10.4197 7.9607 10.4197H7.45008V9.39534H7.91743C8.03282 9.39534 8.14533 9.381 8.25496 9.3523C8.36458 9.32361 8.45978 9.28057 8.54056 9.22318C8.62711 9.16006 8.69346 9.08259 8.73962 8.99077C8.79155 8.89321 8.81751 8.78131 8.81751 8.65506C8.81751 8.45994 8.74827 8.30213 8.6098 8.18162C8.47132 8.05537 8.28381 7.99225 8.04725 7.99225C7.79338 7.99225 7.5972 8.06111 7.45873 8.19884C7.32603 8.33083 7.23371 8.48003 7.18178 8.64645L6.14322 8.22466C6.19515 8.08119 6.27304 7.93486 6.3769 7.78566C6.48075 7.63071 6.61057 7.49298 6.76636 7.37247C6.92791 7.24622 7.11543 7.1458 7.32891 7.07119C7.54239 6.99085 7.78761 6.95068 8.06456 6.95068C8.34727 6.95068 8.60403 6.99085 8.83482 7.07119C9.07138 7.15154 9.27332 7.26344 9.44065 7.40691C9.60797 7.54463 9.73779 7.71105 9.83011 7.90617C9.92242 8.09554 9.96858 8.30213 9.96858 8.52594C9.96858 8.6981 9.9455 8.85304 9.89934 8.99077C9.85895 9.1285 9.80414 9.25188 9.7349 9.36091C9.66567 9.46994 9.58489 9.56463 9.49257 9.64497C9.40603 9.71958 9.3166 9.77983 9.22428 9.82574V9.8946C9.50123 10.0036 9.72913 10.1787 9.908 10.4197C10.0926 10.6607 10.1849 10.9649 10.1849 11.3321C10.1849 11.5904 10.1359 11.8285 10.0378 12.0466C9.93973 12.2589 9.79837 12.4454 9.61374 12.6061C9.43488 12.7668 9.21851 12.8902 8.96464 12.9763C8.71077 13.0681 8.42805 13.114 8.11648 13.114Z",
    fill: "#4285F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2517 12.9763V8.41404L11.2045 8.85304L10.7891 7.89756L12.5287 7.08841H13.3855V12.9763H12.2517Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGCalendar);
export default __webpack_public_path__ + "static/media/g-calendar.463843430c0b2ee77fa699465e36799e.svg";
export { ForwardRef as ReactComponent };